export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    question: '禁漫天堂官方入口在哪里？',
    answer: '禁漫天堂官方入口地址会定期更新以确保访问稳定。建议用户收藏本导航页面，我们会第一时间更新最新的官方入口地址。同时也可以通过官方社交媒体账号获取最新入口信息。请注意辨别真伪，只使用官方发布的地址访问平台。',
  },
  {
    id: 'faq-2',
    question: '如何安全访问禁漫天堂？',
    answer: '为了保障您的访问安全和隐私，建议使用以下方式：1) 使用最新版本的浏览器访问；2) 开启浏览器的安全浏览模式；3) 不要在任何非官方渠道输入个人信息；4) 定期清理浏览器缓存和Cookie；5) 建议使用VPN或代理服务保护网络隐私。本页面提供的所有入口均经过安全验证。',
  },
  {
    id: 'faq-3',
    question: '禁漫天堂是否需要会员注册？',
    answer: '禁漫天堂提供免费和会员两种阅读模式。基础内容可以免费阅读，注册会员后可享受更多权益，包括：无广告阅读、高清画质、提前观看最新更新、专属会员内容、离线下载等。会员注册流程简单快捷，支持多种支付方式。',
  },
  {
    id: 'faq-4',
    question: '禁漫天堂上的漫画资源是否正版？',
    answer: '禁漫天堂与多家国内外知名漫画出版社和作者签订了正式授权协议，平台上的所有漫画内容均为正版授权。我们始终坚持支持原创、尊重版权的原则，为读者提供合法合规的优质漫画阅读体验。如发现任何侵权内容，可通过官方渠道进行举报。',
  },
  {
    id: 'faq-5',
    question: '如何获取禁漫天堂最新更新通知？',
    answer: '您可以通过以下方式获取最新更新通知：1) 注册会员后在个人中心开启推送通知；2) 关注禁漫天堂官方社交媒体账号；3) 订阅邮件通知服务；4) 定期访问本导航页面查看最新动态。我们将通过多渠道确保您不会错过任何精彩内容。',
  },
  {
    id: 'faq-6',
    question: '禁漫天堂支持哪些设备阅读？',
    answer: '禁漫天堂全面支持跨平台阅读，您可以在以下设备上流畅体验：1) PC端浏览器（Windows/Mac/Linux）；2) 手机浏览器（iOS/Android）；3) 平板设备；4) 专用阅读器。平台采用响应式设计，自动适配不同屏幕尺寸，确保最佳阅读体验。',
  },
  {
    id: 'faq-7',
    question: '遇到访问问题怎么办？',
    answer: '如果您在访问禁漫天堂时遇到问题，可以尝试以下解决方案：1) 检查网络连接是否正常；2) 清除浏览器缓存和DNS缓存；3) 尝试更换浏览器或设备；4) 检查是否有防火墙或安全软件阻止访问；5) 联系官方客服获取技术支持。我们的客服团队7x24小时为您服务。',
  },
  {
    id: 'faq-8',
    question: '禁漫天堂如何保护用户隐私？',
    answer: '禁漫天堂高度重视用户隐私保护，采取多重安全措施：1) 全站使用HTTPS加密传输；2) 用户数据采用银行级加密存储；3) 严格的内部数据访问权限控制；4) 定期进行安全审计和渗透测试；5) 遵循国际隐私保护法规。您的个人信息安全是我们的首要任务。',
  },
];